import { BaseType } from '../../base/base-type';
import { EmployerStatusTypeEnum } from '../enum/employer-status-type.enum';

export class EmployerStatusType extends BaseType {
  public declare id: EmployerStatusTypeEnum;
}
